import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight, Menu, X } from "lucide-react";
import { EASE } from "./Reveal";
import { IMAGES } from "../data";

const LINKS = [
  { href: "#layanan", label: "Layanan" },
  { href: "#cara-kerja", label: "Cara Kerja" },
  { href: "#galeri", label: "Galeri" },
  { href: "#harga", label: "Harga" },
  { href: "#faq", label: "FAQ" },
];

export function Brand({ light = false }) {
  return (
    <a href="#beranda" className={`brand ${light ? "brand-light" : ""}`} data-testid="brand-logo-link">
      <img src={IMAGES.logoMark} alt="Logo antarcleaning" />
      <span>
        antar<b>cleaning</b>
      </span>
    </a>
  );
}

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      className={`nav ${scrolled ? "scrolled" : ""}`}
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 0.2, ease: EASE }}
    >
      <div className="container nav-inner">
        <Brand />
        <nav className={open ? "nav-open" : ""} data-testid="main-navigation">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)}>
              {l.label}
            </a>
          ))}
        </nav>
        <a className="nav-cta" href="#pesan" data-testid="navbar-booking-link">
          Pesan Sekarang <ArrowUpRight size={15} />
        </a>
        <button className="menu-btn" onClick={() => setOpen(!open)} aria-label="Menu" data-testid="mobile-menu-button">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
    </motion.header>
  );
}
